<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <!--ver para que el lazy validation xD -->
    <v-layout>
      <v-flex xs12 md5>
        <h5 style="font-weight: bold" class="indigo--text mb-4">
          Complete los siguientes campos:
        </h5>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fechaRecepcion"
              label="Fecha"
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaRecepcion"
            no-title
            @input="menu1 = false"
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-text-field
          v-model="rut"
          label="Rut"
          counter="10"
          maxlength="10"
          @input="dvRut()"
        ></v-text-field>
        <v-text-field v-model="numeroGuia" label="Número Guía"></v-text-field>
        <data-adjunto
          :tipeArchive="tipeArchive"
          :documentoId="id"
          :tipeView="tipeView"
        ></data-adjunto>
        <v-btn
          :disabled="desactivarUpload == true ? true : false"
          class="mb-3"
          color="primary"
          @click="readFile()"
          >Subir</v-btn
        >
      </v-flex>
      <v-flex xs12 md2></v-flex>
      <v-flex xs12 md5 v-if="procesado">
        <h5 style="font-weight: bold" class="indigo--text mb-4">
          Resumen archivo procesado:
        </h5>
        <v-text-field
          :box="true"
          :readonly="true"
          v-model="cajasTotales"
          label="Cantidad de cajas totales procesadas en el fichero"
          @input="$v.cajasTotales.$touch()"
          @blur="tipeView == 'crear' ? v.$cajasTotales.$touch() : null"
        ></v-text-field>
        <v-text-field
          :box="true"
          :readonly="true"
          v-model="cajasNoIdentificadas"
          label="Cantidad de cajas en el fichero que no corresponden"
          @input="$v.cajasNoIdentificadas.$touch()"
          @blur="tipeView == 'crear' ? v.$cajasNoIdentificadas.$touch() : null"
        ></v-text-field>
        <v-text-field
          :box="true"
          :readonly="true"
          v-model="cajasYaRecibidas"
          label="Cantidad de cajas en el fichero que ya se recibieron"
          @input="$v.cajasYaEnviadas.$touch()"
          @blur="tipeView == 'crear' ? v.$cajasYaRecibidas.$touch() : null"
        ></v-text-field>
        <v-text-field
          :box="true"
          :readonly="true"
          v-model="cajasARecibir"
          label="Cantidad de cajas en el fichero que se recibirán"
          @input="$v.cajasAEnviar.$touch()"
          @blur="tipeView == 'crear' ? v.$cajasAEnviar.$touch() : null"
        ></v-text-field>
        <v-btn color="primary" dark @click.stop="dialog = true"
          >Ver detalle Archivo Cargado</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md-12 class="text-md-center" v-if="recibirCajas">
        <v-card-actions class="pb-3" style="display: inline-block">
          <v-btn color="primary" dark class="mb-2" @click="saveRecepcion()">
            Guardar
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline" style="font-weight: bold"
          >Detalle del archivo cargado</v-card-title
        >

        <v-card-title style="font-weight: bold"
          >Códigos de cajas a recibir</v-card-title
        >
        <ul>
          <li v-for="(recibir, index) in arrCajasARecibir" :key="index">
            {{ recibir }}
          </li>
          <li v-if="this.cajasARecibir == 0">
            No se detectaron cajas a ser recibidas.
          </li>
        </ul>
        <v-card-title style="font-weight: bold"
          >Códigos de cajas ya recibidas</v-card-title
        >
        <ul>
          <li v-for="(recibidas, index) in arrYaRecibidas" :key="index">
            {{ recibidas }}
          </li>
          <li v-if="this.cajasYaRecibidas == 0">
            No se detectaron cajas recibidas con anterioridad.
          </li>
        </ul>
        <v-card-title style="font-weight: bold"
          >Códigos de cajas no identificadas</v-card-title
        >
        <ul>
          <li v-for="(desconocidas, index) in arrNoIdentificadas" :key="index">
            {{ desconocidas }}
          </li>
          <li v-if="this.cajasNoIdentificadas == 0">
            No hay cajas ingresadas de forma incorrecta.
          </li>
        </ul>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="indigo darken-1" flat="flat" @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import DataAdjunto from "@/components/AdjuntoData.vue";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
export default {
  name: "recepcion-data",
  components: {
    DataAdjunto,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      arrNoIdentificadas: [],
      arrYaRecibidas: [],
      arrCajasARecibir: [],
      totales: "",
      cajasTotales: null,
      cajasNoIdentificadas: null,
      cajasYaRecibidas: null,
      cajasARecibir: null,
      numeroGuia: "",
      fechaRecepcion: "",
      rut: "",
      hidden: false,
      dv: "",
      row: null,
      radios: "radio-1",
      allowSpaces: false,
      fecha: new Date().toISOString().substr(0, 10),
      menu1: false,
      codigo: "",
      contratoId: "",
      base64Value: "",
      subProceso: "",
      idContrato: "",
      tipeArchive: "",
      procesado: false,
      recibirCajas: true,
      dialog: false,
      desactivarUpload: false,
    };
  },

  validations: {
    fecha: { required },
    rut: { required },
  },

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idSubitem = this.$route.params.idSubitem;
    this.idAcuerdo = this.$route.params.idAcuerdo;
    this.tipeArchive = ".txt";
  },
  mounted() {},

  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      return errors;
    },
  },
  methods: {
    desactivarUpload() {
      return true;
    },
    // activaEnvio() {
    //   if (this.entregaProgramada) {
    //     this.enviarProgreso = false;
    //   } else {
    //     this.base64Value = null;
    //     this.rut = "";
    //     this.rutEntrega = "";
    //     this.dvEntrega = "";
    //     this.numeroGuia = "";
    //     this.cajasTotales = null;
    //     this.cajasNoIdentificadas = null;
    //     this.cajasYaEnviadas = null;
    //     this.cajasAEnviar = null;
    //     this.enviarRecepcion = true;
    //     this.procesado = false;
    //   }
    // },
    submit() {
      this.$v.$touch();
    },
    dvRut() {
      let f = this.formateaRut(this.rut);
      if (f == undefined) {
        this.rut = this.rut;
      } else {
        this.rut = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rut);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dv = obtenerDv(this.rut);
        return console.log("verdadero");
      }
    },
    readFile() {
      let v = this.validaRut(this.rut);
      this.desactivarUpload = true;
      let base64EncodedStr = this.base64Value;
      if (v == false) {
        window.getApp.$emit("ERROR_RUT");
        this.desactivarUpload = false;
        this.location.reload();
      } else {
        this.body = {
          idContrato: this.contratoId,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          numeroGuia: this.numeroGuia,
          idSubItem: this.idSubitem,
          fecha: this.formatoFecha(this.fechaRecepcion),
        };
      }
      axios
        .post("/recepcion/readFile", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("FILE_SEND_PROCESS");
          this.arrNoIdentificadas = this.resp.cajasNoIdentificadas;
          this.arrYaRecibidas = this.resp.cajasYaRecibidas;
          this.arrCajasARecibir = this.resp.cajasARecibir;
          this.cajasTotales = this.resp.cajasTotales.length;
          this.cajasNoIdentificadas = this.resp.cajasNoIdentificadas.length;
          this.cajasYaRecibidas = this.resp.cajasYaRecibidas.length;
          this.cajasARecibir = this.resp.cajasARecibir.length;
          this.procesado = true;
          this.recibirCajas = true;
          this.desactivarUpload = false;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.desactivarUpload = false;
          }
        });
    },

    saveRecepcion() {
      let v = this.validaRut(this.rut);
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let rut = "";
      let dv = "";
      if (this.rut != "") {
        rut = this.obtenerSoloRut(this.rut);
        dv = this.obtenerDv(this.rut);
      }
      if (v == false) {
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else {
        this.body = {
          fecha: this.formatoFecha(this.fechaRecepcion),
          rutEntrega: rut,
          dvEntrega: dv,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          cajasTotales: this.cajasTotales,
          cajasNoIdentificadas: this.cajasNoIdentificadas,
          cajasYaRecibidas: this.cajasYaRecibidas,
          numeroGuia: this.numeroGuia,
          idSubItem: this.idSubitem,
          idContrato: this.contratoId,
        };
      }

      axios
        .post("/recepcion/recibidos", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.volver(this.idAcuerdo, this.idSubitem);
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
      this.loading = false;
    },
    volver(id, idSubitem) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRecepcion",
          params: { tipeView: "consulta", idSubitem: idSubitem, idAcuerdo: id },
        });
      }, 1000);
    },
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
  },
};
</script>
